// Block a person: Matrix's ignored-user list, so the homeserver stops
// delivering their messages and invites. They are not told.

import { useId, useState } from "react";

import { Dialog } from "~/components/Dialog";
import { useMatrix } from "~/context/MatrixContext";
import { setUserBlocked } from "~/lib/matrix";

export function BlockDialog({
  userId,
  name,
  onClose,
}: {
  userId: string;
  name: string;
  onClose: () => void;
}) {
  const { client } = useMatrix();
  const titleId = useId();
  const bodyId = useId();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const block = async () => {
    if (!client) return;
    setBusy(true);
    setError(null);
    try {
      await setUserBlocked(client, userId, true);
      onClose();
    } catch (err) {
      console.warn("setUserBlocked failed", err);
      setError("Couldn't block. Try again.");
      setBusy(false);
    }
  };

  return (
    <Dialog labelledBy={titleId} describedBy={bodyId} onClose={onClose} width="420px">
      <div className="flex flex-col gap-5 p-5">
        <div className="space-y-2">
          <h2 id={titleId} className="text-base font-light text-foreground/90">
            Block {name}?
          </h2>
          <p id={bodyId} className="text-sm font-light leading-6 text-muted-foreground">
            You won't see their messages or invites. They won't be told.
          </p>
        </div>
        {error && (
          <p role="alert" className="text-sm font-light text-destructive-text">
            {error}
          </p>
        )}
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={onClose}
            className="h-11 text-sm font-light text-muted-foreground outline-none hover:text-foreground/80 focus-visible:shadow-neon-cyan"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={() => void block()}
            className="h-11 rounded-lg bg-destructive px-5 text-sm font-medium text-destructive-foreground outline-none transition-opacity hover:opacity-80 focus-visible:shadow-neon-cyan disabled:opacity-40"
          >
            Block
          </button>
        </div>
      </div>
    </Dialog>
  );
}
